import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/use-auth-compat';
import { fetchTeacherEntitlements } from '@/services/teacherEntitlementsService';
import { isReleaseFlagOn } from '@/config/featureFlags';

/**
 * Best-effort, proactive read of the teacher's publish limits (F15) — lets the
 * publish CTA warn/disable itself before an attempt, rather than only after a
 * 409 from POST /publish. Gated behind TEACHER_TIER_BENEFITS so it's inert
 * until that surface is meant to be live.
 */
export function useTeacherEntitlements() {
  const auth = useAuth();
  const token = auth.user?.access_token ?? '';
  return useQuery({
    queryKey: ['teacherEntitlements'],
    queryFn: () => fetchTeacherEntitlements(token),
    enabled: auth.isAuthenticated && isReleaseFlagOn('TEACHER_TIER_BENEFITS'),
    staleTime: 60 * 1000,
  });
}
